
import SidebarComputer from "./Computer/SidebarComputer";
import SidebarMobile from "./Mobile/SidebarMobile";

const sidebarWidthPx = 275;
const sidebarClosedWidthPx = 65;

export default function SideBar({sidebarIsOpen, setSidebarIsOpen, isComputer}) {

    return (
        <>
            {isComputer ?
            (<SidebarComputer
                isOpen={sidebarIsOpen}
                setIsOpen={setSidebarIsOpen}
                width={sidebarWidthPx}
                widthClosed={sidebarClosedWidthPx}
                isComputer={isComputer}
            >
            </SidebarComputer>)
        :
            (<SidebarMobile
                isOpen={sidebarIsOpen}
                setIsOpen={setSidebarIsOpen}
                width={sidebarWidthPx}
                widthClosed={sidebarClosedWidthPx}
                isComputer={isComputer}
            >
            </SidebarMobile>)
        }
        </>

    )
}